export default __webpack_public_path__ + "static/media/order-canceled.3d26a92e.svg";